import { BehaviorSubject } from 'rxjs';

function createStore<T>(initialValue: T) {
  const store: BehaviorSubject<T> = new BehaviorSubject(initialValue);
  return store;
}

export default createStore;